import React, { useCallback, useEffect, useState } from "react";
import {
  Table,
  Card,
  Row,
  Col,
  Button,
  Modal,
  Space,
  Typography,
  Switch,
  Flex,
  message,
  Tabs,
} from "antd";
import PageTitle from "../../components/PageTitle";
import IntlMessage from "../../components/IntlMessage";
import ActionBar from "../../components/ActionBar";
import FilterBar from "../../components/FilterBar";
import _, { debounce } from "lodash";
import { useIntl } from "react-intl";
import routesApi from "../../api/route";
import { useMounted } from "../../hooks/useMounted";
import RouteForm from "./RouteForm";
import RouteSegmentForm from "./RouteSegmentForm";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import routeSegmentsApi from "../../api/route-segments";
import PreviewSeatMap from "../seat-map/PreviewSeatmap";
import RoutePriceForm from "./RoutePriceForm";
import SearchBusOrder from "../order/SearchBusOrder";
import operatorsApi from "../../api/operators";
import dayjs from "dayjs";
import RouteCalendar from "./RouteCalendar";
import RouteFormReturn from "./RouteFormReturn";
import RouteTrajetForm from "./RouteTrajetForm";
import useTime from "../../hooks/useTime";
import dddApi from "../../api/ddd";
import SegmentCalendar from "./SegmentCalendar";

const { Text, Paragraph, Title } = Typography;

const Routes = () => {
  const { isMounted } = useMounted();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: "",
    order_by: "id",
    order_dir: "DESC",
  });
  const [condition, setCondition] = useState({});
  const [items, setItems] = useState([]);
  const [itemRouteGroup, setItemRouteGroup] = useState([]);
  const [loading, setLoading] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalGroup, setTotalGroup] = useState(0);
  const [item, setItem] = useState(null);
  const [modal, setModal] = useState(false);
  const [trajetModal, setTrajetModal] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [reload, setReload] = useState(false);
  const [maps, setMaps] = useState([]);
  const intl = useIntl();
  const [itemSeatmap, setItemSeatmap] = useState("");
  const [operators, setOperators] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [openSegmentModal, setOpenSegmentModal] = useState(false);
  const [isOpenCalendar, setIsOpenCalendar] = useState(false);
  const [openPriceModal, setOpenPriceModal] = useState(false);
  const [routeSelected, setRouteSelected] = useState(null);
  const [updateMaps, setUpdateMaps] = useState(null);
  const [indexUpdateSegment, setIndexUpdateSegment] = useState(null);
  const [modalReturn, setModalReturn] = useState(false);
  const [disabledSeat, setDisabledSeat] = useState([]);
  const [loadingSeatMap, setLoadingSeatMap] = useState(false);
  const [loadingUpdatePriceDDD, setLoadingUpdatePriceDDD] = useState(false);
  const [loadingButton, setLoadingButton] = useState(null);
  const [isOpenGroupCalendar, setIsOpenGroupCalendar] = useState(false);


  const { convertToAnyTimezone } = useTime();
  useEffect(() => {
    var filter = {
      limit: 9999,
      page: 1,
      order_by: "id",
      order_dir: "DESC",
    };
    Promise.all([
      operatorsApi.getAll(filter),
      routesApi.getDestinations(),
      // destinationsApi.getAll(filter),
    ]).then((res) => {
      if (Array.isArray(res[0]?.data)) {
        setOperators(res[0]?.data);
      }
      console.log("res[1]?.data", res[1]);
      if (Array.isArray(res[1]?.data)) {
        setDestinations(res[1]?.data);
      }
    });
  }, []);

  const fetch = useCallback(async () => {
    if (isMounted.current) {
      setLoading(true);
      const res = await routesApi.getAll(filter);
      const data = res?.data;

      if (Array.isArray(data)) {
        setItems(data);
        setTotal(res.total);
      }

      const res_group = await routesApi.getAllGroupRoute(filter);
      const data_group = res_group?.data;

      if (Array.isArray(data_group)) {
        setItemRouteGroup(data_group);
        setTotalGroup(res_group.total);
      }
      setLoading(false);
    }
  }, [isMounted, filter, reload]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const fetchListRouteDDD = async (record) => {
    try {
      const response = await dddApi.getListSegmentDDD({
        depart: record?.depart,
        arrivee: record?.arrivee,
        date: record?.date,
      });

      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onOpenPreviewSeatMap = (record = null) => {
    setIsPreview(true);
    setItemSeatmap(record);
  };

  const handleDisabledSeat = async (seat) => {
    setDisabledSeat((prev) =>
      _.includes(prev, seat)
        ? prev.filter((num) => num !== seat)
        : [...prev, seat]
    );
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === "search") {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const getOrder = (order) => {
    if (order === "ascend") return "ASC";
    if (order === "descend") return "DESC";
    return "DESC";
  };

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : "id",
    });
  };

  const onOpenModal = (record) => {
    setItem(record);
    setModal(true);
  };

  const onOpenTrajetModal = (record) => {
    setItem(record?.segments.map((item) => JSON.parse(item.params)));
    setTrajetModal(true);
  };

  const onCloseModal = () => {
    setModal(false);
  };

  const onOpenModalReturn = (record) => {
    setItem(record);
    setModalReturn(true);
  };

  const onCloseModalReturn = () => {
    setModalReturn(false);
  };

  const onOpenSegmentModal = (record, routeId, index) => {
    setItem(record);
    setRouteSelected(routeId);
    setOpenSegmentModal(true);
    setIndexUpdateSegment(index);
  };
  const onOpenCalendarModal = (record, routeId) => {
    setItem(record);
    setIsOpenCalendar(true);
  };

  const onOpenCalendarSegmentModal = (record, routeId) => {
    setItem(record);
    setIsOpenGroupCalendar(true);
  };

  const onOpenPriceModal = (record, routeId) => {
    setItem(record);
    setRouteSelected(routeId);
    setOpenPriceModal(true);
  };

  const onCloseSegmentModal = () => {
    setOpenSegmentModal(false);
  };

  const onClosePriceModal = () => {
    setOpenPriceModal(false);
  };

  const onDelete = async (selectedRowKeys) => {
    await routesApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: "global.close" }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    onReload();
  };

  const onDeleteSegment = (id) => {
    Modal.confirm({
      title: intl.formatMessage({ id: "global.delete_confirm" }),
      okText: intl.formatMessage({ id: "global.yes" }),
      okType: "danger",
      onOk: async () => {
        await routeSegmentsApi.delete(`${id}`).catch((error) => {
          console.error(error);
          Modal.error({
            title: error.data.message,
            okText: intl.formatMessage({ id: "global.close" }),
          });
          setLoading(false);
        });
        onReload();
      },
      onCancel() {},
    });
  };

  const onChangeStatus = async (isChecked, record) => {
    setLoading(true);
    await routesApi.updateStatus(record.id, {
      status: isChecked,
    });
    onReload();
    setLoading(false);
  };

  const onChangeStatusSegment = async (isChecked, record) => {
    setLoading(true);

    try {
      await routeSegmentsApi.updateStatus(record.id, {
        status: isChecked,
      });

      onReload();
    } catch (error) {
      console.error("Failed to update status:", error);
    } finally {
      setLoading(false);
    }
  };

  const onChangeRouteGroupStatusSegment = async (isChecked, record) => {
    setLoading(true);

    try {
      await routeSegmentsApi.updateStatus(record.id, {
        status: isChecked,
      });

      onReload();
    } catch (error) {
      console.error("Failed to update status:", error);
    } finally {
      setLoading(false);
    }
  };

  const onChangeRouteGroupStatus = async (isChecked, record) => {
    setLoading(true);
    await routesApi.updateGroupStatus(record.ids, {
      status: isChecked,
    });
    onReload();
    setLoading(false);
  };
  const onCopy = async (selectedRowKeys) => {
    if (selectedRowKeys.length > 1) {
      Modal.error({
        title: "Please select only one row",
        okText: intl.formatMessage({ id: "global.close" }),
      });
      return;
    }
    await routesApi.copy(selectedRowKeys).catch((error) => {
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: "global.close" }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    onReload();
  };

  const onCreateReturn = async (id) => {
    await routesApi.onCreateReturn(id).catch((error) => {
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: "global.close" }),
      });
      setLoading(false);
    });

    onReload();
  };
  const onCreateRateDDD = async () => {
    setLoading(true);
    await routesApi
      .onCreateDateDDD()
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        Modal.error({
          title: error.data.message,
          okText: intl.formatMessage({ id: "global.close" }),
        });
        setLoading(false);
      });
    setLoading(false);
    onReload();
  };
  const columns = [
    {
      title: <IntlMessage id="global.sku" />,
      key: "sku",
      width: 100,
      sorter: true,
      dataIndex: "sku",
      render: (text, record) => {
        return (
          <>
            <Space direction="vertical" size="small">
              <Button
                type="link"
                size="small"
                onClick={() => onOpenModal(record)}
                shape="round"
              >
                {record?.sku ?? "N/A"}
              </Button>

              <Button
                size="small"
                icon={<PlusOutlined />}
                type="primary"
                onClick={() => onOpenSegmentModal(record, record.id)}
                shape="round"
              >
                <IntlMessage id="global.add_segment" />
              </Button>

              {record?.segments.length > 0 ? (
                <Button
                  size="small"
                  icon={<PlusOutlined />}
                  type="primary"
                  onClick={() => onOpenPriceModal(record, record.id)}
                  shape="round"
                >
                  <IntlMessage id="global.add_price" />
                </Button>
              ) : null}
              <Button
                size="small"
                icon={<PlusOutlined />}
                type="primary"
                onClick={() => onOpenModalReturn(record)}
                shape="round"
              >
                <IntlMessage id="global.create_return_route" />
              </Button>
            </Space>
          </>
        );
      },
    },
    {
      title: <IntlMessage id="global.operator" />,
      key: "operator.title",
      sorter: true,
      dataIndex: "operator.title",
      width: 100,
      render: (_, record) => {
        return `${record?.operator?.title}`;
      },
    },
    {
      title: <IntlMessage id="global.route" />,
      key: "start_location.title",
      sorter: true,
      dataIndex: "start_location",
      width: 100,
      render: (_, record) => {
        const destinations = record.destinations.map((item) => item.title);
        return destinations.join(" - ");
      },
    },
    {
      title: <IntlMessage id="global.start_time" />,
      key: "start_time",
      dataIndex: "start_time",
      width: 100,
      render: (_, record) => {
        return record?.min_depart
          ? dayjs(record.min_depart, "HH:mm:ss").format("HH:mm")
          : null;
      },
    },
    {
      title: <IntlMessage id="global.calendar" />,
      key: "start_location.title",
      sorter: true,
      dataIndex: "start_location",
      width: 100,
      render: (_, record) => {
        return (
          <Button
            type="link"
            size="small"
            onClick={() => {
              record?.segments.length > 0
                ? onOpenCalendarModal(record)
                : Modal.error({
                    title: "Please create segment before",
                    okText: intl.formatMessage({ id: "global.close" }),
                  });
            }}
            shape="round"
          >
            <IntlMessage id="global.calendar" />
          </Button>
        );
      },
    },
    {
      title: <IntlMessage id="global.vehicle" />,
      key: "seatmap.title",
      sorter: true,
      dataIndex: ["seatmap.title", "seatmap", "block_layout"],
      width: 100,
      render: (_, record) => {
        return (
          <Button
            type="link"
            size="small"
            onClick={() => onOpenPreviewSeatMap(record)}
            shape="round"
          >
            {record?.seatmap?.title}
          </Button>
        );
      },
    },
    {
      title: <IntlMessage id="global.status" />,
      key: "status",
      dataIndex: "status",
      width: 100,
      render: (e, record) => (
        <Space direction="vertical" size={2}>
          <Switch
            checkedChildren={""}
            unCheckedChildren={""}
            checked={!!e}
            onChange={(isChecked) => onChangeStatus(isChecked, record)}
          />
        </Space>
      ),
    },
    {
      title: <IntlMessage id="global.id" />,
      width: 20,
      key: "id",
      sorter: true,
      dataIndex: "id",
      render: (text, record, index) => {
        const segmentDDD = record?.segments.filter(
          (item) => item.params !== null && item.from_price === null
        );

        const handleUpdatePriceSegment = async (data, id) => {
          setLoadingUpdatePriceDDD(true);

          setLoadingButton(id);

          try {
            const result = await routesApi.syncPriceSegmentDDD(data);
            console.log("test result: ", result);
          } catch (error) {
            console.error("eroro ", error);
            setLoadingUpdatePriceDDD(false);
          } finally {
            setLoadingUpdatePriceDDD(false);
            message.success("Update price segment successfully");
            onReload();
          }
        };
        return (
          <div style={{ textAlign: "center" }}>
            {record.id}
            <br />
            {record?.params && JSON.parse(record?.params)?.from_ddd && (
              <>
                {record?.segments.length > 0 ? (
                  <Button
                    type="link"
                    size="small"
                    onClick={() => onOpenTrajetModal(record)}
                    shape="round"
                  >
                    Trajet id :
                    {JSON.parse(record?.segments?.[0]?.params)
                      ? JSON.parse(record?.segments?.[0]?.params)?.trajet_id
                      : null}
                  </Button>
                ) : null}
                <br />
                {segmentDDD && segmentDDD.length > 0 ? (
                  <>
                    <Button
                      size="small"
                      loading={
                        loadingUpdatePriceDDD && loadingButton === record.id
                      }
                      onClick={() =>
                        handleUpdatePriceSegment(segmentDDD, record?.id)
                      }
                      shape="round"
                    >
                      Update price DDD
                    </Button>
                    <br />
                  </>
                ) : null}
              </>
            )}
            <Text>
              Created :{" "}
              {convertToAnyTimezone(record?.created_at).format(
                "DD/MM/YYYY HH:mm:ss"
              )}
            </Text>
            {!record?.params || record?.segments.length === 0 ? (
              <SyncRouteSegmetnDDD
                record={{
                  date: dayjs().format("YYYY-MM-DD"),
                  depart: record?.start_location?.title,
                  arrivee: record?.end_location?.title,
                }}
                route={record?.id}
              />
            ) : null}
          </div>
        );
      },
    },
    // {
    //   title: <IntlMessage id="global.created_at" />,
    //   key: 'created_at',
    //   dataIndex: 'created_at',
    //   width: 150,
    //   render: (text, record, index) => {
    //     return (
    //       <Text>{dayjs(record?.created_at).format('DD/MM/YYYY HH:mm')}</Text>
    //     );
    //   },
    // },
  ];

  const expandedRowRender = (data) => {
    const columns = [
      {
        title: "",
        key: "id",
        width: 80,
        render: (_, record) => {
          return (
            <Flex gap={8}>
              <Button
                size="small"
                onClick={() => {
                  onOpenSegmentModal(record, data.id, record?.id);
                  setUpdateMaps(record?.route?.maps);
                  // console.log("this is record: ", record);
                }}
                icon={<EditOutlined />}
              />
              <Button
                danger
                size="small"
                onClick={() => onDeleteSegment(record.id)}
                icon={<DeleteOutlined />}
              />
            </Flex>
          );
        },
      },
      {
        title: <IntlMessage id="global.from" />,
        key: "start_stop",
        dataIndex: "start_stop",
        width: 100,
        render: (_, record) => {
          return `${record?.start_stop?.title}`;
        },
      },
      {
        title: <IntlMessage id="global.to" />,
        key: "end_stop",
        dataIndex: "end_stop",
        width: 100,
        render: (_, record) => {
          return `${record?.end_stop?.title}`;
        },
      },
      {
        title: <IntlMessage id="global.start_time" />,
        key: "start_time",
        dataIndex: "start_time",
        width: 50,
        render: (_, record) => {
          return record?.start_time
            ? dayjs(record.start_time, "HH:mm:ss").format("HH:mm")
            : null;
        },
      },
      {
        title: <IntlMessage id="global.end_time" />,
        key: "end_time",
        dataIndex: "end_time",
        width: 50,
        render: (_, record) => {
          return record?.end_time
            ? dayjs(record.end_time, "HH:mm:ss").format("HH:mm")
            : null;
        },
      },
      {
        title: <IntlMessage id="global.price" />,
        key: "from_price",
        dataIndex: "from_price",
        width: 50,
        render: (_, record) => {
          return `${record?.from_price ?? ""}`;
        },
      },

      {
        title: <IntlMessage id="global.status" />,
        key: "status",
        dataIndex: "status",
        width: 100,
        render: (e, record) => (
          <Space direction="vertical" size={2}>
            <Switch
              checkedChildren={""}
              unCheckedChildren={""}
              checked={!!e}
              onChange={(isChecked) => onChangeStatusSegment(isChecked, record)}
            />
          </Space>
        ),
      },
      {
        title: <IntlMessage id="global.id" />,
        key: "id",
        dataIndex: "id",
        width: 20,
        render: (_, record) => {
          return `${record?.id}`;
        },
      },
    ];

    return (
      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={data.segments ?? []}
        rowKey="id"
        size="small"
        pagination={false}
      />
    );
  };

  const SyncRouteSegmetnDDD = ({ record, route }) => {
    const [segmentDDD, setSegmentDDD] = useState(null);
    const [isSync, setIsSync] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isHasData, setIsHasData] = useState(false);
    const handleSynchSegment = async (route_id) => {
      if (isSync) return;
      setIsSync(true);
      const params = {
        from_ddd: true,
      };

      try {
        let data;
        const res = await routesApi.updateParams(route_id, {
          params: JSON.stringify(params),
        });
        if (res) {
          const syncSegment = await dddApi.syncSegmentDDD({
            data: segmentDDD,
            route_id: route_id,
          });

          console.log("syncSegment: ", syncSegment);

          if (syncSegment.length > 0) {
            message.success("Sync segment DDD successfully.");
            onReload();
          } else if (syncSegment.length === 0) {
            message.info("There is no route for you to sync.");
            onReload();
          } else {
            message.error("Created failed.");
            onReload();
          }
        }
      } catch (error) {
        message.error(`Error: ${error.message}`);
      }
    };

    // useEffect(() => {
    //   const fetchData = async () => {
    //     if (record) {
    //       setLoading(true);
    //       try {
    //         const result = await fetchListRouteDDD(record);
    //         console.log("result: ", result);
    //         if (result.trajetVoyage.length > 0) {
    //           setIsHasData(true);
    //           setSegmentDDD(result?.trajetVoyage);
    //         }
    //       } catch (error) {
    //         message.error(`Error: ${error.message}`);
    //       } finally {
    //         setLoading(false);
    //       }
    //     }
    //   };
    //   fetchData();
    // }, [record]);

    return (
      <div style={{ marginTop: 12 }}>
        {segmentDDD && route && !isSync && isHasData ? (
          <Button onClick={() => handleSynchSegment(route)} loading={loading}>
            Sync
          </Button>
        ) : null}
      </div>
    );
  };

  const columns_group = [
    {
      title: <IntlMessage id="global.route" />,
      key: "start_location.title",
      sorter: true,
      dataIndex: "start_location",
      width: 100,
      render: (_, record) => {
        const destinations = record.destinations.map((item) => item.title);
        return destinations.join(" - ");
      },
    },
    {
      title: <IntlMessage id="global.operator" />,
      key: "operator.title",
      sorter: true,
      dataIndex: "operator.title",
      width: 100,
      render: (_, record) => {
        return `${record?.operator?.title}`;
      },
    },

    // {
    //   title: <IntlMessage id="global.start_time" />,
    //   key: 'start_time',
    //   dataIndex: 'start_time',
    //   width: 100,
    //   render: (_, record) => {
    //     return record?.min_depart
    //       ? dayjs(record.min_depart, 'HH:mm:ss').format('HH:mm')
    //       : null;
    //   },
    // },
    {
      title: <IntlMessage id="global.status" />,
      key: "status",
      dataIndex: "status",
      width: 60,
      render: (e, record) => (
        <Space direction="vertical" size={2}>
          <Switch
            checkedChildren={""}
            unCheckedChildren={""}
            checked={record.routes.some((item) => item.status)}
            onChange={(isChecked) =>
              onChangeRouteGroupStatus(isChecked, record)
            }
          />
        </Space>
      ),
    },

    // {
    //   title: <IntlMessage id="global.created_at" />,
    //   key: 'created_at',
    //   dataIndex: 'created_at',
    //   width: 150,
    //   render: (text, record, index) => {
    //     return (
    //       <Text>{dayjs(record?.created_at).format('DD/MM/YYYY HH:mm')}</Text>
    //     );
    //   },
    // },
  ];
  const expandedRowRenderGroup = (data) => {
    console.log("data", data);
    const columns = [
      {
        title: <IntlMessage id="global.sku" />,
        key: "sku",
        width: 100,
        sorter: true,
        dataIndex: "sku",
        render: (text, record) => {
          return (
            <>
              <Space direction="vertical" size="small">
                <Button
                  type="link"
                  size="small"
                  onClick={() => onOpenModal(record)}
                  shape="round"
                >
                  {record?.sku ?? "N/A"}
                </Button>

                <Button
                  size="small"
                  icon={<PlusOutlined />}
                  type="primary"
                  onClick={() => onOpenSegmentModal(record, record.id)}
                  shape="round"
                >
                  <IntlMessage id="global.add_segment" />
                </Button>

                {record?.segments.length > 0 ? (
                  <Button
                    size="small"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() => onOpenPriceModal(record, record.id)}
                    shape="round"
                  >
                    <IntlMessage id="global.add_price" />
                  </Button>
                ) : null}
                <Button
                  size="small"
                  icon={<PlusOutlined />}
                  type="primary"
                  onClick={() => onOpenModalReturn(record)}
                  shape="round"
                >
                  <IntlMessage id="global.create_return_route" />
                </Button>
              </Space>
            </>
          );
        },
      },
      {
        title: <IntlMessage id="global.route" />,
        key: "start_location.title",
        sorter: true,
        dataIndex: "start_location",
        width: 100,
        render: (_, record) => {
          const destinations = record.destinations.map((item) => item.title);
          return destinations.join(" - ");
        },
      },
      {
        title: <IntlMessage id="global.start_time" />,
        key: "start_time",
        dataIndex: "start_time",
        width: 100,
        render: (_, record) => {
          return record?.min_depart
            ? dayjs(record.min_depart, "HH:mm:ss").format("HH:mm")
            : null;
        },
      },
      {
        title: <IntlMessage id="global.calendar" />,
        key: "start_location.title",
        sorter: true,
        dataIndex: "start_location",
        width: 100,
        render: (_, record) => {
          return (
            <Button
              type="link"
              size="small"
              onClick={() => {
                record?.segments.length > 0
                  ? onOpenCalendarModal(record)
                  : Modal.error({
                      title: "Please create segment before",
                      okText: intl.formatMessage({ id: "global.close" }),
                    });
              }}
              shape="round"
            >
              <IntlMessage id="global.calendar" />
            </Button>
          );
        },
      },
      {
        title: <IntlMessage id="global.vehicle" />,
        key: "seatmap.title",
        sorter: true,
        dataIndex: ["seatmap.title", "seatmap", "block_layout"],
        width: 100,
        render: (_, record) => {
          return (
            <Button
              type="link"
              size="small"
              onClick={() => onOpenPreviewSeatMap(record)}
              shape="round"
            >
              {record?.seatmap?.title}
            </Button>
          );
        },
      },
      {
        title: <IntlMessage id="global.status" />,
        key: "status",
        dataIndex: "status",
        width: 130,
        render: (e, record) => (
          <Space direction="vertical" size={2}>
            <Switch
              checkedChildren={""}
              unCheckedChildren={""}
              checked={!!e}
              onChange={(isChecked) => onChangeStatus(isChecked, record)}
            />
          </Space>
        ),
      },
      {
        title: <IntlMessage id="global.id" />,
        width: 20,
        key: "id",
        sorter: true,
        dataIndex: "id",
        render: (text, record, index) => {
          const segmentDDD = record?.segments.filter(
            (item) => item.params !== null && item.from_price === null
          );

          const handleUpdatePriceSegment = async (data, id) => {
            setLoadingUpdatePriceDDD(true);

            setLoadingButton(id);

            try {
              const result = await routesApi.syncPriceSegmentDDD(data);
              console.log("test result: ", result);
            } catch (error) {
              console.error("eroro ", error);
              setLoadingUpdatePriceDDD(false);
            } finally {
              setLoadingUpdatePriceDDD(false);
              message.success("Update price segment successfully");
              onReload();
            }
          };
          return (
            <div style={{ textAlign: "center" }}>
              {record.id}
              <br />
              {record?.params && JSON.parse(record?.params)?.from_ddd && (
                <>
                  {record?.segments.length > 0 ? (
                    <Button
                      type="link"
                      size="small"
                      onClick={() => onOpenTrajetModal(record)}
                      shape="round"
                    >
                      Trajet id :
                      {JSON.parse(record?.segments?.[0]?.params)
                        ? JSON.parse(record?.segments?.[0]?.params)?.trajet_id
                        : null}
                    </Button>
                  ) : null}
                  <br />
                  {segmentDDD && segmentDDD.length > 0 ? (
                    <>
                      <Button
                        size="small"
                        loading={
                          loadingUpdatePriceDDD && loadingButton === record.id
                        }
                        onClick={() =>
                          handleUpdatePriceSegment(segmentDDD, record?.id)
                        }
                        shape="round"
                      >
                        Update price DDD
                      </Button>
                      <br />
                    </>
                  ) : null}
                </>
              )}
              <Text>
                Created :{" "}
                {convertToAnyTimezone(record?.created_at).format(
                  "DD/MM/YYYY HH:mm:ss"
                )}
              </Text>
              {!record?.params || record?.segments.length === 0 ? (
                <SyncRouteSegmetnDDD
                  record={{
                    date: dayjs().format("YYYY-MM-DD"),
                    depart: record?.start_location?.title,
                    arrivee: record?.end_location?.title,
                  }}
                  route={record?.id}
                />
              ) : null}
            </div>
          );
        },
      },
      // {
      //   title: <IntlMessage id="global.created_at" />,
      //   key: 'created_at',
      //   dataIndex: 'created_at',
      //   width: 150,
      //   render: (text, record, index) => {
      //     return (
      //       <Text>{dayjs(record?.created_at).format('DD/MM/YYYY HH:mm')}</Text>
      //     );
      //   },
      // },
    ];

    return (
      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={data.routes ?? []}
        rowKey="id"
        size="small"
        pagination={false}
        expandable={{
          expandedRowRender: expandedRowRenderGroupChild,
          defaultExpandAllRows: false,
        }}
      />
    );
  };

  const expandedRowRenderGroupChild = (data) => {
    console.log("data", data);
    const columns = [
      {
        title: "",
        key: "id",
        width: 80,
        render: (_, record) => {
          return (
            <Flex gap={8}>
              <Button
                size="small"
                onClick={() => {
                  onOpenSegmentModal(record, record.route.id, record?.id);
                  setUpdateMaps(record?.route?.maps);
                  // console.log("this is record: ", record);
                }}
                icon={<EditOutlined />}
              />
              <Button
                danger
                size="small"
                onClick={() => onDeleteSegment(record.id)}
                icon={<DeleteOutlined />}
              />
            </Flex>
          );
        },
      },
      {
        title: <IntlMessage id="global.from" />,
        key: "start_stop",
        dataIndex: "start_stop",
        width: 100,
        render: (_, record) => {
          return `${record?.start_stop?.title}`;
        },
      },
      {
        title: <IntlMessage id="global.to" />,
        key: "end_stop",
        dataIndex: "end_stop",
        width: 100,
        render: (_, record) => {
          return `${record?.end_stop?.title}`;
        },
      },
      {
        title: <IntlMessage id="global.start_time" />,
        key: "start_time",
        dataIndex: "start_time",
        width: 50,
        render: (_, record) => {
          return record?.start_time
            ? dayjs(record.start_time, "HH:mm:ss").format("HH:mm")
            : null;
        },
      },
      {
        title: <IntlMessage id="global.end_time" />,
        key: "end_time",
        dataIndex: "end_time",
        width: 50,
        render: (_, record) => {
          return record?.end_time
            ? dayjs(record.end_time, "HH:mm:ss").format("HH:mm")
            : null;
        },
      },
      {
        title: <IntlMessage id="global.price" />,
        key: "from_price",
        dataIndex: "from_price",
        width: 50,
        render: (_, record) => {
          return `${record?.from_price ?? ""}`;
        },
      },
      // {
      //   title: <IntlMessage id="global.calendar" />,
      //   key: 'start_location.title',
      //   sorter: true,
      //   dataIndex: 'start_location',
      //   width: 100,
      //   render: (_, record) => {
      //     return (
      //       <Button
      //         type="link"
      //         size="small"
      //         onClick={() => onOpenCalendarSegmentModal(record)}
      //         shape="round">
      //         <IntlMessage id="global.calendar" />
      //       </Button>
      //     );
      //   },
      // },
      // {
      //   title: <IntlMessage id="global.vehicle" />,
      //   key: 'seatmap.title',
      //   sorter: true,
      //   dataIndex: ['seatmap.title', 'seatmap', 'block_layout'],
      //   width: 100,
      //   render: (_, record) => {
      //     return (
      //       <Button
      //         type="link"
      //         size="small"
      //         onClick={() => onOpenPreviewSeatMap(record?.route)}
      //         shape="round">
      //         {record?.route?.seatmap?.title}
      //       </Button>
      //     );
      //   },
      // },
      {
        title: <IntlMessage id="global.status" />,
        key: "status",
        dataIndex: "status",
        width: 50,
        render: (e, record) => (
          <Space direction="vertical" size={2}>
            <Switch
              checkedChildren={""}
              unCheckedChildren={""}
              checked={!!e}
              onChange={(isChecked) =>
                onChangeRouteGroupStatusSegment(isChecked, record)
              }
            />
          </Space>
        ),
      },
      {
        title: <IntlMessage id="global.id" />,
        key: "id",
        dataIndex: "id",
        width: 20,
        render: (_, record) => {
          return `${record?.id}`;
        },
      },
    ];

    return (
      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={data.segments ?? []}
        rowKey="id_1"
        size="small"
        pagination={false}
      />
    );
  };

  const tabItems = [
    {
      key: "1",
      label: <IntlMessage id="global.group_route" />,
      children: (
        <>
          <Table
            key="have-data-1"
            // tableLayout="auto"
            columns={columns_group}
            dataSource={itemRouteGroup}
            onChange={onChangeTable}
            rowKey="id"
            size="small"
            loading={loading}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50"],
              total: totalGroup,
              current: filter.page,
              pageSize: filter.limit,
            }}
            // rowSelection={rowSelection}
            expandable={{
              expandedRowRender: expandedRowRenderGroup,
              defaultExpandAllRows: true,
            }}
            // rowSelection={rowSelection}
          />
        </>
      ),
    },
    {
      key: "2",
      label: <IntlMessage id="global.default" />,
      children: (
        <>
          <Table
            key="have-data"
            // tableLayout="auto"
            columns={columns}
            dataSource={items}
            onChange={onChangeTable}
            rowKey="id"
            size="small"
            loading={loading}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50"],
              total: total,
              current: filter.page,
              pageSize: filter.limit,
            }}
            // rowSelection={rowSelection}
            expandable={{
              expandedRowRender,
              defaultExpandAllRows: true,
            }}
            rowSelection={rowSelection}
          />
        </>
      ),
    },
  ];
  return (
    <React.Fragment>
      <Flex vertical gap={8}>
        <Row justify="space-between" align={"middle"}>
          <Col>
            <PageTitle title={<IntlMessage id="global.routes" />} />
          </Col>

          <Col>
            <ActionBar
              isShowAddButton={true}
              onAdd={onOpenModal}
              onCopy={() => onCopy(selectedRowKeys)}
              onRefresh={() => onReload()}
              onDelete={() => onDelete(selectedRowKeys)}
              isShowPublishButtons={false}
              isShowCopyButton={true}
              deleteMessage={
                "Warning! You are about to delete this route and its associated records. Are you sure you want to delete this record?"
              }
              add_new="Nouvelle route"
              isShowDeleteButton={true}
              isDisabled={!(selectedRowKeys.length > 0)}
            >
              {/* <Button type="default" onClick={() => onCreateRateDDD()}>
                <IntlMessage id="global.create_price_ddd" />
              </Button> */}
            </ActionBar>
          </Col>
        </Row>

        <Card bordered={false}>
          <Flex vertical gap={8}>
            <FilterBar
              onFilter={onFilter}
              data={[
                {
                  name: "operator_id",
                  data: operators,
                  placeholder: <IntlMessage id="global.operator" />,
                },
                {
                  name: "start_location",
                  // data: items.map((item) => item.start_location),
                  data: destinations,
                  placeholder: <IntlMessage id="global.from" />,
                },
                {
                  name: "end_location",
                  // data: items.map((item) => item.end_location),
                  data: destinations,
                  placeholder: <IntlMessage id="global.to" />,
                },
                {
                  name: "status",
                  data: [
                    { title: "Active", value: "1" },
                    { title: "Inactive", value: "0" },
                  ],
                  placeholder: <IntlMessage id="global.status" />,
                },
              ]}
            />
            <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
          </Flex>
        </Card>
      </Flex>

      {isPreview ? (
        <PreviewSeatMap
          open={isPreview}
          isModal={true}
          disabledSeat={disabledSeat}
          setDisabledSeat={setDisabledSeat}
          onClose={() => {
            setIsPreview(false);
            setDisabledSeat([]);
          }}
          onReload={onReload}
          routesData={itemSeatmap}
          handleDisabledSeat={handleDisabledSeat}
          loadingSeatMap={loadingSeatMap}
          setLoadingSeatMap={setLoadingSeatMap}
        />
      ) : null}

      {modal ? (
        <RouteForm
          open={modal}
          onClose={onCloseModal}
          currentData={item}
          onReload={onReload}
        />
      ) : null}

      {trajetModal ? (
        <RouteTrajetForm
          open={trajetModal}
          onClose={() => setTrajetModal(false)}
          currentData={item}
          onReload={onReload}
        />
      ) : null}

      {modalReturn ? (
        <RouteFormReturn
          open={modalReturn}
          onClose={onCloseModalReturn}
          currentData={item}
          onReload={onReload}
        />
      ) : null}

      {openSegmentModal ? (
        <RouteSegmentForm
          open={openSegmentModal}
          onClose={onCloseSegmentModal}
          currentData={item}
          routeId={routeSelected}
          onReload={onReload}
          maps={maps}
          setMaps={setMaps}
          indexUpdateSegment={indexUpdateSegment}
          updateMaps={updateMaps}
        />
      ) : null}

      {openPriceModal ? (
        <RoutePriceForm
          open={openPriceModal}
          onClose={onClosePriceModal}
          currentData={item}
          routeId={routeSelected}
          onReload={onReload}
          maps={maps}
          setMaps={setMaps}
        />
      ) : null}

      {isOpenCalendar ? (
        <RouteCalendar
          open={isOpenCalendar}
          onClose={() => setIsOpenCalendar(false)}
          currentData={item}
          onReload={onReload}
          reload={reload}
        />
      ) : null}

      {isOpenGroupCalendar ? (
        <SegmentCalendar
          open={isOpenGroupCalendar}
          onClose={() => setIsOpenGroupCalendar(false)}
          currentData={item}
          onReload={onReload}
          reload={reload}
        />
      ) : null}
    </React.Fragment>
  );
};

export default Routes;
